// extracted by mini-css-extract-plugin
export var table = "_yb-0";